/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type ScoreSource = "ANNOTATION" | "API" | "EVAL";
export const ScoreSource = {
  Annotation: "ANNOTATION",
  Api: "API",
  Eval: "EVAL",
} as const;
